import { RedirectToSignIn, useAuth } from '@clerk/react-router'
import type { ReactNode } from 'react'
import { ErrorState, QueryState } from '../../core'
import { DatadogRumUserIdentity } from './DatadogRumUserIdentity'
import { InitialPageLoadComplete } from './InitialPageLoadContext'
import { CurrentUserContext } from '../utils/currentUserContext'
import { useCurrentUserQuery } from '../hooks/useCurrentUserQuery'

export interface CurrentUserProtectedRouteProps {
  children: ReactNode
}

export function CurrentUserProtectedRoute({
  children,
}: CurrentUserProtectedRouteProps) {
  const auth = useAuth()

  if (auth.isLoaded === false) {
    return null
  }

  if (auth.isSignedIn === false) {
    return (
      <InitialPageLoadComplete>
        <RedirectToSignIn />
      </InitialPageLoadComplete>
    )
  }

  return <CurrentUserBoundary>{children}</CurrentUserBoundary>
}

function CurrentUserBoundary({ children }: CurrentUserProtectedRouteProps) {
  const currentUserQuery = useCurrentUserQuery()

  return (
    <QueryState
      query={currentUserQuery}
      loading={<></>}
      error={(error) => {
        return (
          <InitialPageLoadComplete>
            <ErrorState error={error} />
          </InitialPageLoadComplete>
        )
      }}
    >
      {currentUserQuery.isSuccess === true ? (
        <CurrentUserContext.Context value={currentUserQuery.data}>
          <DatadogRumUserIdentity />
          {children}
        </CurrentUserContext.Context>
      ) : null}
    </QueryState>
  )
}
